import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import moment from "moment";
import DescriptionList from "../shared/DescriptionList";
import DescriptionItem from "../shared/DescriptionItem";
import {connect} from 'react-redux';
import {fetchManagersIfNeeded} from "../state/actions/managers";
import {fetchJobsIfNeeded} from "../state/actions/jobs";


class ShiftDetails extends Component {
  componentDidMount() {
    this.props.fetchJobsIfNeeded();
    this.props.fetchManagersIfNeeded(this.props.business);
  }

  render() {
    const {classes, shift, managers, jobs} = this.props;

    // We convert the job and manager ID to actual objects
    const manager = managers && managers.filter(manager => manager.id === shift.manager)[0];
    const job = jobs && jobs.filter(job => job.id === shift.job)[0];

    return (
      <section className={classes.detailSection}>
        <Typography className={classes.title} variant={'subheading'}>Details</Typography>
        <DescriptionList>
          {manager && <DescriptionItem term={'Manager'} details={manager.name}/>}
          {job && <DescriptionItem term={'Job Type'} details={job.name}/>}
          <DescriptionItem term={'Date'} details={moment(shift.start_time).format('dddd, MMM Do')}/>
          <DescriptionItem term={'Start Time'} details={moment(shift.start_time).format('h:mm A')}/>
          <DescriptionItem term={'End Time'} details={moment(shift.end_time).format('h:mm A')}/>
          <DescriptionItem term={'Hourly Wage'} details={'$' + shift.wage}/>
          <DescriptionItem term={'Pros Required'} details={shift.required_pros}/>
          <DescriptionItem term={'Address'} details={shift.address}/>
          {shift.attire && (<DescriptionItem term={'Attire'} details={shift.attire}/>)}
          {shift.duties && (
            <DescriptionItem term={'Duties'} details={<div dangerouslySetInnerHTML={{__html: shift.duties}}/>}/>)}
          {shift.comments && (
            <DescriptionItem term={'Comments'} details={<div dangerouslySetInnerHTML={{__html: shift.comments}}/>}/>)}
          {shift.event && (<DescriptionItem term={'Event Name'} details={shift.event}/>)}
        </DescriptionList>
      </section>
    );
  }
}

const styles = (theme) => ({
  detailSection: {
    marginBottom: theme.spacing.unit * 4,
  },
  title: {
    marginBottom: theme.spacing.unit * 2,
    fontWeight: 'bold',
  },
  confirmedPros: {
    marginTop: theme.spacing.unit,
    paddingLeft: 0,
    listStyle: 'inside',
  },
});

const mapStateToProps = (state) => ({
  jobs: state.jobs.items,
  managers: state.managers.items,
  business: state.business.item,
});

const mapDispatchToProps = (dispatch) => ({
  fetchJobsIfNeeded: () => dispatch(fetchJobsIfNeeded()),
  fetchManagersIfNeeded: (business) => dispatch(fetchManagersIfNeeded(business)),
});

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(ShiftDetails));



// WEBPACK FOOTER //
// ./src/parts/ShiftDetails.js